export function hosts() {
  if (process.env.VUE_APP_API_HOSTS) {
    return JSON.parse(process.env.VUE_APP_API_HOSTS);
  } else {
    return [];
  }
}

export function defaultHost() {
  const currentHosts = hosts();

  return currentHosts[Object.keys(currentHosts)[0]];
}
